/** Splits the original array into a pair of arrays, where `first` array contains elements for which `predicate` yielded
 *  `true`, while `second` array contains elements for which `predicate` yielded `false`.
 * @param {Array} array
 * @param {(item)=>Boolean} predicate
 */
export default (array, predicate) =>
  array.reduce(
    (partitions, item) => {
      const [first, second] = partitions;
      const partition = predicate(item) ? first : second;
      partition.push(item);
      return partitions;
    },
    [[], []]
  );
